export var ObjectLocale = {
    'zh-CN': {
        title: '对象容器',
    },
    'en-US': {
        title: 'Object',
    },
};
